import { createAction, handleActions } from 'redux-actions';
import { fromJS, Map } from 'immutable';
import { createSelector } from 'reselect';

// Actions
export const fetchDeviceSchema = createAction('TEST_FORM_FETCH_DEVICE_SCHEMA');
export const fetchDeviceSchemaSuccess = createAction('TEST_FORM_FETCH_DEVICE_SCHEMA_SUCCESS');
export const fetchDeviceSchemaFail = createAction('TEST_FORM_FETCH_DEVICE_SCHEMA_FAIL');
export const testFormClear = createAction('TEST_FORM_CLEAR');

export const actions = {
  fetchDeviceSchema,
  fetchDeviceSchemaSuccess,
  fetchDeviceSchemaFail,
  testFormClear,
};

const defaultState = fromJS({
  deviceSchema: new Map(),
  isFetchingDeviceSchema: false,
  error: null,
});

export default handleActions({
  [fetchDeviceSchema]: state => state.merge({
    isFetchingDeviceSchema: true,
  }),

  [fetchDeviceSchemaSuccess]: (state, action) => state.merge({
    deviceSchema: action.payload,
    isFetchingDeviceSchema: false,
  }),

  [fetchDeviceSchemaFail]: (state, action) => state.merge({
    error: action.payload,
    isFetisFetchingDeviceSchemaching: false,
  }),

  [testFormClear]: () => defaultState,
}, defaultState);

const testFormSelector = state => state.testForm;

export const isFetchingDeviceSchema = createSelector(
  testFormSelector,
  state => state.get('isFetchingDeviceSchema'),
);

export const getDeviceSchema = createSelector(
  testFormSelector,
  state => state.get('deviceSchema'),
);



// WEBPACK FOOTER //
// ./src/store/test-form-reducer.js